var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTransactionCheckDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58801 13C3.58801 12.4477 4.03573 12 4.58801 12H30.4751C30.7591 12 31.0297 12.1207 31.2194 12.3321L35.3323 16.915C35.4969 17.0985 35.588 17.3364 35.588 17.5829V25C35.588 25.5523 35.1403 26 34.588 26H4.58801C4.03573 26 3.58801 25.5523 3.58801 25V13Z",
    stroke: "#20242E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.588 15.8C9.48344 15.8 8.58801 16.5163 8.58801 17.4C8.58801 18.2837 9.48344 19 10.588 19C11.6926 19 12.588 19.7163 12.588 20.6C12.588 21.4837 11.6926 22.2 10.588 22.2M10.588 15.8C11.3283 15.8 11.9746 16.1218 12.3204 16.6M10.588 15.8V15M10.588 22.2L10.588 23M10.588 22.2C9.84775 22.2 9.2014 21.8782 8.85559 21.4",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.588 12V16C30.588 16.5523 31.0357 17 31.588 17H35.588",
    stroke: "#20242E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.588 17C21.9213 17 16.588 17 16.588 17",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.588 21C19.9213 21 16.588 21 16.588 21",
    stroke: "#20242E",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionCheckDeposit);
export default __webpack_public_path__ + "static/media/ic-transaction-check-deposit.92d1b0e583c45d0451e01c0a8e5041b7.svg";
export { ForwardRef as ReactComponent };